export default {
    name: "mwc-locales-mixin",
    inject: ["locale"],
    data() {
        return {
            defaultConfig: {
                settings: {
                    languageId: this.locale.language
                }
            }
        };
    },
    methods: {
        getUILabel(key, interpolations) {
            if (!key) {
                return "";
            }
            return this.locale && this.locale.language && this.labeller.getLabel(key.toUpperCase(), interpolations);
        },
        updateLanguage() {
            this.labeller.updateLanguage(this.locale.language);
            this.settings.languageId = this.locale.language;
        }
    },
    watch: {
        locale: {
            handler: function() {
                this.updateLanguage();
            },
            deep: true
        }
    }
};
